import { v4 as uuid } from 'uuid';

export default class Actions {
  actions = [];

  addAction(icon, action) {
    this.actions.push({
      id: uuid(),
      icon,
      action,
    });
    return this;
  }

  getActions() {
    return this.actions;
  }
}
